import { Component, Inject, OnInit } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { ActivatedRoute, Router } from '@angular/router';
import {
	NgbCalendar,
	NgbDate,
	NgbDateParserFormatter,
} from '@ng-bootstrap/ng-bootstrap';

import { Date_range } from '../../core/models/date-range';
import { User } from '../../core/models/user';
import { OldDataService } from 'src/app/core/services/old-data.service';
import { SelectedOptionsService } from '../../services/selected-options-service/selected-options.service';
import { QC_THEADS } from '../timezones';
import * as dayjs from 'dayjs';
import { AuthenticationService } from 'src/app/core/services/auth.service';
import { UtilsService } from 'src/app/services/utils/utils.service';
import { LeadService } from 'src/app/services/lead/lead.service';
import { UserService } from 'src/app/services/user/user.service';
import { CampaignService } from 'src/app/services/campaigns/campaign.service';
import { ColumnMode } from '@swimlane/ngx-datatable';
import { QC_COLUMNS } from 'src/app/shared/constants';
import * as XLSX from 'xlsx';
import { saveAs } from 'file-saver';



@Component({
	selector: 'app-quality-control',
	templateUrl: './quality-control.component.html',
	styleUrls: ['./quality-control.component.scss'],
})
export class QualityControlComponent implements OnInit {
	public showMenu: boolean;
	public leadsLoading: boolean;
	public selectedLead: any;
	public leads: any[];
	public unreviewed: any[];
	public overproduced: any[];
	public approved: any[];
	public denied: any[];
	public fix: any[];
	public leadTab: string;
	public leadsMsg: any;
	public unreviewedLeadsMsg: any[];
	public approvedLeadsMsg: any[];
	public rescheduleLeadsMsg: any[];
	public deniedLeadsMsg: any[];

	public totalUnreviewed: number;
	public totalApproved: number;
	public totalDenied: number;
	public totalFix: number;
	public totalOverproduced: number;

	public usersLoading: boolean;

	public usersMsg: string;

	public userTab: string;

	public campaigns: any[];
	public activeTab: string;
	public hoveredDate: NgbDate | null = null;
	public fromDate: NgbDate | null;
	public toDate: NgbDate | null;

	public stripe_back = '';
	public alerted = false;
	public user: User;

	public tableConfig = {
		tableClass: 'table-striped table-hover',
		theadClass: 'thead-dark',
		dblclickRows: true,
	};

	public buttons = [];
	public changeColor = ['prospect_company', 'replacement_status'];
	public theads = QC_THEADS;

	dateRange_: Date_range = {
		dateStart: dayjs(new Date()),
		dateEnd: dayjs(new Date()),
	};

	rowPerPage = 50;

	employeeUsers = [];
	ColumnMode = ColumnMode;
	columns = QC_COLUMNS;


	constructor(
		private router: Router,
		private calendar: NgbCalendar,
		public formatter: NgbDateParserFormatter,
		private sanitizer: DomSanitizer,
		private dataService: OldDataService,
		public utils: UtilsService,
		public authenticationService: AuthenticationService,
		public selectedOptions: SelectedOptionsService,
		private leadSrv: LeadService,
		private userSrv: UserService,
		private campaignSrv: CampaignService
	) {
		this.unreviewed = [];
		this.overproduced = [];
		this.approved = [];
		this.denied = [];
		this.fix = [];

		this.leadsLoading = false;
		this.leadTab = '';
		this.totalUnreviewed = 0;
		this.totalApproved = 0;
		this.totalDenied = 0;
		this.totalFix = 0;
		this.totalOverproduced = 0;
		this.usersLoading = false;
		this.activeTab = 'campaigns';

		this.showMenu = true;

		this.user = this.authenticationService.currentUserValue;

		selectedOptions.qcControl.agent = 'All';

		if (
			this.selectedOptions.qcControl.fromDate === '' &&
			this.selectedOptions.qcControl.toDate === ''
		) {
			this.fromDate = this.calendar.getPrev(
				this.calendar.getToday(),
				'd',
				91,
			);
			this.toDate = this.calendar.getToday();

			this.dateRange_ = {
				dateStart: dayjs(this.utils.ngbDateToPHP(this.fromDate)),
				dateEnd: dayjs(this.utils.ngbDateToPHP(this.toDate)),
			};

			this.selectedOptions.qcControl.fromDate =
				this.utils.ngbDateToPHP(this.fromDate) + '00:00:00';
			this.selectedOptions.qcControl.toDate =
				this.utils.ngbDateToPHP(this.toDate) + '23:59:59';
		} else {
			var fromDate_ = new Date(this.selectedOptions.qcControl.fromDate);
			this.fromDate = new NgbDate(
				fromDate_.getFullYear(),
				fromDate_.getMonth() + 1,
				fromDate_.getDate(),
			);

			var toDate_ = new Date(this.selectedOptions.qcControl.toDate);
			this.toDate = new NgbDate(
				toDate_.getFullYear(),
				toDate_.getMonth() + 1,
				toDate_.getDate(),
			);
		}
	}

	ngOnInit() {
		this.getAllUsers();
		this.getCampaigns();
		this.selectSearch();
	}

	toggleLeadsList(type: string) {
		this.leads = [];

		if (type == 'unreviewed') {
			this.leads = [];
			this.leads = this.unreviewed;
			this.selectedOptions.qcControl.selectedTab = type;
			this.leadsMsg = this.unreviewedLeadsMsg;
		} else if (type == 'approved') {
			this.leads = [];
			this.leads = this.approved;
			this.selectedOptions.qcControl.selectedTab = type;
			this.leadsMsg = this.approvedLeadsMsg;
		} else if (type == 'denied') {
			this.leads = this.denied;
			this.selectedOptions.qcControl.selectedTab = type;
			this.leadsMsg = this.deniedLeadsMsg;
		} else if (type == 'fix') {
			this.leads = this.fix;
			this.selectedOptions.qcControl.selectedTab = type;
			this.leadsMsg = this.rescheduleLeadsMsg;
		} else if (type == 'overproduced') {
			this.leads = this.overproduced;
			this.selectedOptions.qcControl.selectedTab = type;
			this.leadsMsg = this.rescheduleLeadsMsg;
		}

	}

	getAllUsers() {
		this.usersLoading = true;
		this.userSrv.getEmployeesForSelect().subscribe((data: any)=>{
			this.employeeUsers = data.body;
			this.usersLoading = false;
		});
	}

	getCampaigns() {
		this.campaignSrv.getCampaignsForSelect().subscribe((data: any)=>{
			this.campaigns = data.body;
		});
	}

	selectSearch() {
		this.leadsLoading = true;
		this.leads = [];
		this.unreviewed = [];
		this.approved = [];
		this.denied = [];
		this.fix = [];
		this.activeTab = 'leads';

		this.leadSrv.selectSearch(this.selectedOptions.qcControl).subscribe((data: any)=>{
			for (let lead of data.body) {

				lead.meet_type = this.utils.getTypesIcons(lead.meet_type);
				if(lead.free_type == '' || lead.free_type == null){
					lead.free_type = '-';
				}

				if (lead.lead_status == 'Approved') {
					switch (lead.replacement_status) {
						case 'Approved':
							lead.class = {
								class: 'bg-success',
								key: 'prospect_company',
							};
							break;
						case 'Replaced':
							lead.class = {
								class: 'bg-purple',
								key: 'prospect_company',
							};
							break;
						case 'Rescheduled':
							lead.class = {
								class: 'bg-grey-dark',
								key: 'prospect_company',
							};
							break;
						case 'Pending Replacement':
							lead.class = {
								class: 'bg-purple-light',
								key: 'prospect_company',
							};
							break;
						case 'Pending Reschedule':
							lead.class = {
								class: 'bg-grey-light',
								key: 'prospect_company',
							};
							break;
						case 'QC Calls':
							lead.class = {
								class: 'bg-oliva',
								key: 'prospect_company',
							};
							break;

						default:
							lead.class = {
								class: 'bg-success',
								key: 'prospect_company',
							};
							break;
					}
					this.approved.push(lead);
				} else if (lead.lead_status == 'Denied') {
					lead.class = {
						class: 'bg-danger',
						key: 'prospect_company',
					};
					this.denied.push(lead);
				} else if (lead.lead_status == 'Fix') {
					lead.class = {
						class: 'bg-warning',
						key: 'prospect_company',
					};
					this.fix.push(lead);
				}

				if (lead.payed == 'T') {
					lead.payed =
						this.sanitizer.bypassSecurityTrustHtml(
							`<i class="ri-checkbox-line"></i>`,
						);
				} else {
					lead.payed =
						this.sanitizer.bypassSecurityTrustHtml(
							`<i class="ri-checkbox-blank-line"></i>`,
						);
				}

				if (lead.campaign_active === '1') {
					lead.campaign_name =
						this.sanitizer.bypassSecurityTrustHtml(
							`<i class="ri-check-line" aria-hidden="true" title="Active campaign"></i> ${lead.campaign_name}`,
						);
				} else {
					lead.campaign_name =
						this.sanitizer.bypassSecurityTrustHtml(
							`<i class="ri-prohibited-line" aria-hidden="true" title="Deactivated campaign"></i> ${lead.campaign_name}`,
						);
				}

				switch (lead.difficult) {
					case 'Easy':
						lead.difficult =
							this.sanitizer.bypassSecurityTrustHtml(
								`<i class="ri-flag-2-fill text-success" aria-hidden="true"></i>`,
							);
						break;
					case 'Medium':
						lead.difficult =
							this.sanitizer.bypassSecurityTrustHtml(
								`<i class="ri-flag-2-fill text-warning" aria-hidden="true"></i>`,
							);
						break;

					case 'Hard':
						lead.difficult =
							this.sanitizer.bypassSecurityTrustHtml(
								`<i class="ri-flag-2-fill text-danger" aria-hidden="true"></i>`,
							);
						break;

					default:
						break;
				}

				if (lead.confirmation == 'T') {
					lead.confirmation = 'CONFIRMED';
				} else {
					lead.confirmation = '';
				}

				if (lead.calificado === 'T') {
					lead.calificado = 'GOOD';
				} else {
					lead.calificado = 'BAD';
				}
			}
			this.totalApproved = this.approved.length;
			this.totalDenied = this.denied.length;
			this.totalFix = this.fix.length;
			this.leadsLoading = false;
			this.getAllUnreviewed();
		});
	}

	getAllUnreviewed() {
		this.leadSrv.getAllUnreviewed().subscribe((data: any) => {
			this.unreviewed = [];
			for (let lead of data.body) {
				lead.class = {
					class: 'bg-info',
					key: 'prospect_company',
				};
				if (lead.payed == 'T') {
					lead.payed = this.sanitizer.bypassSecurityTrustHtml(
						`<i class="ri-checkbox-line"></i>`,
					);
				} else {
					lead.payed = this.sanitizer.bypassSecurityTrustHtml(
						`<i class="ri-checkbox-blank-line"></i>`,
					);
				}
				switch (lead.difficult) {
					case 'Easy':
						lead.difficult =
							this.sanitizer.bypassSecurityTrustHtml(
								`<i class="ri-flag-2-fill text-success" aria-hidden="true"></i>`,
							);
						break;
					case 'Medium':
						lead.difficult =
							this.sanitizer.bypassSecurityTrustHtml(
								`<i class="ri-flag-2-fill text-warning" aria-hidden="true"></i>`,
							);
						break;

					case 'Hard':
						lead.difficult =
							this.sanitizer.bypassSecurityTrustHtml(
								`<i class="ri-flag-2-fill text-danger" aria-hidden="true"></i>`,
							);
						break;

					default:
						break;
				}

				if (lead.campaign_active === '1') {
					lead.campaign_name =
						this.sanitizer.bypassSecurityTrustHtml(
							`<i class="ri-check-line" aria-hidden="true" title="Active campaign"></i> ${lead.campaign_name}`,
						);
				} else {
					lead.campaign_name =
						this.sanitizer.bypassSecurityTrustHtml(
							`<i class="ri-prohibited-line" aria-hidden="true" title="Deactivated campaign"></i> ${lead.campaign_name}`,
						);
				}

				lead.meet_type = this.utils.getTypesIcons(lead.meet_type);

				if (lead.calificado === 'T') {
					lead.calificado = 'GOOD';
				} else {
					lead.calificado = 'BAD';
				}

				if (lead.overproduced === 'T') {
					this.overproduced.push(lead);
				} else {
					this.unreviewed.push(lead);
				}
			}

			this.totalOverproduced = this.overproduced.length;
			this.totalUnreviewed = this.unreviewed.length;
			this.toggleLeadsList(this.selectedOptions.qcControl.selectedTab);
		})
	}

	editLead(lead: any) {
		this.router.navigateByUrl('/lead-edit/' + lead.id);
	}

	dateSelected(dates: any) {
		this.selectedOptions.qcControl.fromDate =
			dayjs(dates.dateStart).format('YYYY-MM-DD') + ' 00:00:00';
		this.selectedOptions.qcControl.toDate =
			dayjs(dates.dateEnd).format('YYYY-MM-DD') + ' 23:59:59';
		this.selectSearch();
	}

	// Function to determine cell class based on status
	getCellClass = (row: any) => {
		if (row.replacement_status === 'Approved') {
			return 'bg-success text-center';
		}
		return 'text-center';
	}

	isShowed(column: string){
		if (this.columns.find((col) => col.prop === column)) {
			return this.columns.find((col) => col.prop === column).visible;
		} else {
			return false;
		}
	}

	toggleColumn(column: string) {
		if (this.columns.find((col) => col.prop === column)) {
			this.columns.find((col) => col.prop === column).visible = !this.columns.find((col) => col.prop === column).visible;
		}
	}

	getBgColor(lead_status: string, replacement_status: string) {
		if (lead_status == 'Approved') {
			switch (replacement_status) {
				case 'Approved':
					return 'bg-success';
				case 'Replaced':
					return 'bg-purple';
				case 'Rescheduled':
					return 'bg-grey-dark';
				case 'Pending Replacement':
					return 'bg-purple-light';
				case 'Pending Reschedule':
					return 'bg-grey-light';
				case 'QC Calls':
					return 'bg-oliva';
				default:
					return 'bg-success';
			}
		} else if (lead_status == 'Denied') {
			return 'bg-danger';
		} else if (lead_status == 'Fix') {
			return 'bg-warning';
		} else if (lead_status == 'Unreviewed') {
			return 'bg-info';
		}
	}

	reloadTable(){
		this.selectSearch();
	}

	exportToExcel(): void {
		const ws: XLSX.WorkSheet = XLSX.utils.json_to_sheet(this.leads);
		const wb: XLSX.WorkBook = XLSX.utils.book_new();
		XLSX.utils.book_append_sheet(wb, ws, 'Sheet1');
		const excelBuffer: any = XLSX.write(wb, { bookType: 'xlsx', type: 'array' });
		const data: Blob = new Blob([excelBuffer], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8' });
		saveAs(data, 'table.xlsx');
	}
}
